import { useLanguage } from "@/contexts/LanguageContext";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";

export const ProofStrip = () => {
  const { t } = useLanguage();
  const { visibleItems, itemRefs } = useScrollAnimation(0.2);

  const stats = [
    { value: "UX", labelKey: "proof.stat1" },
    { value: "UI", labelKey: "proof.stat2" },
    { value: "Systems", labelKey: "proof.stat3" },
  ];

  return (
    <section aria-label={t("proof.title")} className="max-w-[1300px] mx-auto px-6 py-12 md:py-16">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 border-y border-border py-10">
        {stats.map((stat, index) => (
          <div
            key={stat.labelKey}
            ref={(el) => (itemRefs.current[index] = el)}
            className={`space-y-2 transition-all duration-700 ${
              visibleItems.has(index) ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
            style={{ transitionDelay: `${index * 80}ms` }}
          >
            <div className="text-3xl md:text-5xl font-mono font-normal tracking-tight text-foreground">
              {stat.value}
            </div>
            <p className="text-sm text-muted-foreground leading-snug">{t(stat.labelKey)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
